module.exports = __webpack_public_path__ + "img/5.b95a64e6.jpg";